export const PROCESSO_SIEF_EXIGIBILIDADE = [
  {
    "ni": "03763656000154",
    "numeroProcesso": "10805720022202382",
    "inTamanhoProcesso": "2",
    "situacao": "SUSPENSO-APREC. AGRAVO DESP. DENEG. REC. ESPEC. E/OU JULG. REC. ESP",
    "localizacao": "PROTOCOLO-DRF-STO ANDRE-SP",
    "dataInicio": "2025-04-03",
    "dataPrazoFinal": null,
    "dataValidadeAnaliseMedidaJudicial": null,
    "identificadorProcesso": "MTA4MDU3MjAwMjIyMDIzODJ8NXwyNnwwMzc2MzY1NjAwMDE1NA=="
  },
  {
    "ni": "03763656000154",
    "numeroProcesso": "10805720050202481",
    "inTamanhoProcesso": "2",
    "situacao": "AGUARDANDO CIENCIA-RESULTADO DE JULGAMENTO IMPUGNACAO (CONTRIBUINTE",
    "localizacao": "PROTOCOLO-DRF-STO ANDRE-SP",
    "dataInicio": "2025-04-03",
    "dataPrazoFinal": null,
    "dataValidadeAnaliseMedidaJudicial": null,
    "identificadorProcesso": "MTA4MDU3MjAwNTAyMDI0ODF8Mnw0fDAzNzYzNjU2MDAwMTU0"
  },
  {
    "ni": "03763656000154",
    "numeroProcesso": "10805720051202425",
    "inTamanhoProcesso": "2",
    "situacao": "AGUARDANDO CIENCIA-RESULTADO DE JULGAMENTO DO REC.VOLUNTARIO (CONTR",
    "localizacao": "PROTOCOLO-DRF-STO ANDRE-SP",
    "dataInicio": "2025-04-03",
    "dataPrazoFinal": null,
    "dataValidadeAnaliseMedidaJudicial": null,
    "identificadorProcesso": "MTA4MDU3MjAwNTEyMDI0MjV8Mnw4fDAzNzYzNjU2MDAwMTU0"
  },
  {
    "ni": "03763656000154",
    "numeroProcesso": "10805720051202425",
    "inTamanhoProcesso": "2",
    "situacao": "SUSPENSO-JULG.REC.ESP.PROC.-AG.CIENCIA RESULT.EX.ADMISSIB.(CONTRIB.",
    "localizacao": "PROTOCOLO-DRF-STO ANDRE-SP",
    "dataInicio": "2025-04-03",
    "dataPrazoFinal": null,
    "dataValidadeAnaliseMedidaJudicial": null,
    "identificadorProcesso": "MTA4MDU3MjAwNTEyMDI0MjV8NXw0NnwwMzc2MzY1NjAwMDE1NA=="
  },
  {
    "ni": "03763656000154",
    "numeroProcesso": "10805720052202470",
    "inTamanhoProcesso": "2",
    "situacao": "SUSPENSO-JULGAMENTO DO RECURSO VOLUNTARIO",
    "localizacao": "PROTOCOLO-DRF-STO ANDRE-SP",
    "dataInicio": "2025-04-03",
    "dataPrazoFinal": null,
    "dataValidadeAnaliseMedidaJudicial": null,
    "identificadorProcesso": "MTA4MDU3MjAwNTIyMDI0NzB8NXwyMHwwMzc2MzY1NjAwMDE1NA=="
  },
  {
    "ni": "03763656000154",
    "numeroProcesso": "10805720053202414",
    "inTamanhoProcesso": "2",
    "situacao": "SUSPENSO-JULGAMENTO DO RECURSO VOLUNTARIO",
    "localizacao": "PROTOCOLO-DRF-STO ANDRE-SP",
    "dataInicio": "2025-04-03",
    "dataPrazoFinal": null,
    "dataValidadeAnaliseMedidaJudicial": null,
    "identificadorProcesso": "MTA4MDU3MjAwNTMyMDI0MTR8NXwyMHwwMzc2MzY1NjAwMDE1NA=="
  },
  {
    "ni": "03763656000154",
    "numeroProcesso": "10805720055202411",
    "inTamanhoProcesso": "2",
    "situacao": "AGUARDANDO CIENCIA-RESULTADO DE JULGAMENTO IMPUGNACAO (CONTRIBUINTE",
    "localizacao": "PROTOCOLO-DRF-STO ANDRE-SP",
    "dataInicio": "2025-04-03",
    "dataPrazoFinal": null,
    "dataValidadeAnaliseMedidaJudicial": null,
    "identificadorProcesso": "MTA4MDU3MjAwNTUyMDI0MTF8Mnw0fDAzNzYzNjU2MDAwMTU0"
  },
  {
    "ni": "03763656000154",
    "numeroProcesso": "10830720010202421",
    "inTamanhoProcesso": "2",
    "situacao": "SUSPENSO-JULGAMENTO DA IMPUGNACAO",
    "localizacao": "PROTOCOLO-DRF-STO ANDRE-SP",
    "dataInicio": "2025-04-03",
    "dataPrazoFinal": null,
    "dataValidadeAnaliseMedidaJudicial": null,
    "identificadorProcesso": "MTA4MzA3MjAwMTAyMDI0MjF8NXwxNnwwMzc2MzY1NjAwMDE1NA=="
  },
  {
    "ni": "03763656000154",
    "numeroProcesso": "10830720016202407",
    "inTamanhoProcesso": "2",
    "situacao": "AGUARDANDO CIENCIA-DESPACHO DENEGATORIO DO REC.VOLUNTARIO (CONTRIBU",
    "localizacao": "PROTOCOLO-DRF-STO ANDRE-SP",
    "dataInicio": "2025-04-03",
    "dataPrazoFinal": null,
    "dataValidadeAnaliseMedidaJudicial": null,
    "identificadorProcesso": "MTA4MzA3MjAwMTYyMDI0MDd8Mnw3fDAzNzYzNjU2MDAwMTU0"
  }
];

export const PROCESSO_SIEF_COBRANCA = [
  {
    "ni": "03763656000154",
    "numeroProcesso": "10805720049202456",
    "inTamanhoProcesso": "2",
    "situacao": "DEVEDOR",
    "localizacao": "PROTOCOLO-DRF-STO ANDRE-SP",
    "dataInicio": null,
    "dataPrazoFinal": null,
    "dataValidadeAnaliseMedidaJudicial": null,
    "identificadorProcesso": "MTA4MDU3MjAwNDkyMDI0NTZ8NHwwfDAzNzYzNjU2MDAwMTU0"
  },
  {
    "ni": "03763656000154",
    "numeroProcesso": "10805720054202469",
    "inTamanhoProcesso": "2",
    "situacao": "DEVEDOR",
    "localizacao": "PROTOCOLO-DRF-STO ANDRE-SP",
    "dataInicio": null,
    "dataPrazoFinal": null,
    "dataValidadeAnaliseMedidaJudicial": null,
    "identificadorProcesso": "MTA4MDU3MjAwNTQyMDI0Njl8NHwwfDAzNzYzNjU2MDAwMTU0"
  },
  {
    "ni": "03763656000154",
    "numeroProcesso": "10830720015202454",
    "inTamanhoProcesso": "2",
    "situacao": "DEVEDOR",
    "localizacao": "PROTOCOLO-DRF-STO ANDRE-SP",
    "dataInicio": null,
    "dataPrazoFinal": null,
    "dataValidadeAnaliseMedidaJudicial": null,
    "identificadorProcesso": "MTA4MzA3MjAwMTUyMDI0NTR8NHwwfDAzNzYzNjU2MDAwMTU0"
  }
];
